import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { Slider } from '@hhgtech/hhg-components/mantine'

import { Banner } from 'components/atoms/banner'
import { WeekOption } from 'components/organisms/dueDateCalculatorCard/selectItem'

import { ArrowButtonProps } from './arrowButton'

export const StyledHeading = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
`

export const StyledResultBanner = styled(Banner)`
  ${MediaQueries.mbDown} {
    padding: 8px 16px;
    gap: 8px;
  }
`

export const StyledDueDateImage = styled.div`
  position: relative;
`

export const StyledCalendar = styled.div`
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 90px;
  min-height: 70px;
  position: absolute;
  inset: 0;
  top: 50%;
  left: 50%;
  transform: translate(-30%, -30%);
  .header {
    padding-top: 4px;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #ffffff;
    background: ${theme?.colors.pink800};
    width: 100%;
    height: 100%;
  }
  .day {
    padding-top: 3px;
    padding-bottom: 8px;
    font-weight: 700;
    font-size: 36px;
    line-height: 42px;
  }
`

export const StyledSlider = styled(Slider)`
  z-index: 0;
  pointer-events: none;
  user-select: none;
  .mantine-Slider-trackContainer {
    height: 8px;
  }
  .mantine-Slider-bar {
    border-radius: 0;
    background-color: ${theme?.colors.pink600};
  }
  .mantine-Slider-track {
    height: 8px;
    &::before {
      background-color: ${theme?.colors.neutral200};
    }
  }
  .mantine-Slider-thumb {
    background-color: ${theme?.colors.pink600};
    border: 0;
    width: 0.0625rem;
    height: 0.5rem;
  }
  .mantine-Slider-mark {
    border: none;
    width: 0.375rem;
    height: 0.375rem;
  }
  .mantine-Slider-markWrapper {
    top: 0.0625rem;
  }
  .mantine-Slider-label {
    padding: 0.4375rem 0.5rem;
    background: ${theme?.colors.white};
    border-radius: 0.25rem;
    top: 1rem;
    font-weight: 400;
    transform: translateX(10px);

    &::before {
      content: '';
      position: absolute;
      border-top: 0 solid white;
      border-bottom: 5px solid white;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      top: -5px;
      left: calc(50% - 10px);
      transform: translate(-50%, 0);
    }
  }

  [aria-valuenow='35'],
  [aria-valuenow='36'],
  [aria-valuenow='37'],
  [aria-valuenow='38'],
  [aria-valuenow='39'] {
    .mantine-Slider-label {
      transform: translateX(-40%);

      &::before {
        left: calc(100% - 10px);
        transform: translate(-100%, 0);
      }
    }
  }
  [aria-valuenow='40'] {
    .mantine-Slider-label {
      transform: translateX(-50%);

      &::before {
        left: calc(100% - 10px);
        transform: translate(-100%, 0);
      }
    }
  }

  .mantine-Slider-marksContainer {
    z-index: 3;
  }
`
export const StyledTrimeterSlider = styled.div<{ isSponsored?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  justify-content: space-between;
  & > div {
    width: 100%;
  }
  .btn-text {
    white-space: nowrap;
    text-transform: uppercase;
  }
  ${MediaQueries.mbDown} {
    margin-block: 24px;
    .btn-text {
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 160px;
    }
  }
  ${MediaQueries.mbUp} {
    position: sticky;
    top: ${({ isSponsored }) => (isSponsored ? '103px' : '57px')};
    z-index: 4;
  }
`

export const StyledWeightGainBanner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 24px;
  gap: 24px;
  /* Neutral/Neutral-50 */
  background: ${theme?.colors.neutral50};
  border-radius: 8px;
  img {
    width: 96px;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  ${MediaQueries.mbDown} {
    margin-block: 40px;
    padding: 16px;
    gap: 16px;
    img {
      width: 64px;
    }
    .content {
      gap: 8px;
    }
  }
`

export const StyledArrowButton = styled.div<ArrowButtonProps>`
  position: absolute;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  top: 50%;
  /* White */

  background: #ffffff;
  /* System/z2 (normal) */

  box-shadow: 0px 10px 16px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);

  transform: ${(props) =>
    props.position === 'right'
      ? `translateY(-50%) rotate(180deg)`
      : 'translateY(-50%)'};
  cursor: pointer;
`

export const StyledWeekOption = styled(WeekOption)`
  margin-inline: -16px;
`
